module.exports = __webpack_public_path__ + "static/media/23.0572b696.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/23.png
// module id = 1462
// module chunks = 0